<template>
  <FilterBase
    label="Question"
    :show-toggletip="!model"
    toggletip-text="Start typing to see a list of suggested research questions available for this Community"
    toggletip-activator-label="question filter tooltip"
  >
    <v-row dense>
      <v-col :md="true" class="py-0">
        <ComboboxBase
          v-if="!model"
          ref="autocomplete"
          v-model="model"
          :searchable="true"
          :disable-auto-focus="true"
          no-options-label="No matching questions found"
          placeholder="Start typing the question here..."
          :name="ariaLabel"
          :options="items"
          @updateInput="questionSelected"
          @search="updateSearch"
        ></ComboboxBase>
        <div v-else>
          <a
            ref="clearButton"
            href="#"
            class="font-weight-bold"
            @click.prevent="clearQuestion"
            >Clear question</a
          >
        </div>
      </v-col>
    </v-row>
    <v-row v-if="model">
      <v-col class="font-italic">
        <span class="font-weight-bold">Question:</span>
        <span>{{ model.name }}</span>
      </v-col>
    </v-row>
  </FilterBase>
</template>

<script>
import FilterBase from "~/components/communities/components/FilterBase.vue";
import debounce from "~/store/manage/utilities/debounce";
import runGraphQLQuery from "~/store/manage/utilities/runGraphQLQuery";
import { questionSearch } from "~/store/graphql/queries/questionSearch.graphql";
import ComboboxBase from "~/components/combobox/ComboboxBase.vue";

const getResultsWithDelay = debounce(async function getResultsWithDelay(val) {
  this.isLoading = true;

  const params = { searchTerm: val, journalId: this.community.journalId };

  await runGraphQLQuery(questionSearch, params, this.$axios)
    .then((data) => {
      this.items = data.results;
    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.error(error);
    })
    .finally(() => {
      this.isLoading = false;
      this.isSearching = false;
    });
}, 500);

export default {
  name: "QuestionSelection",
  components: {
    FilterBase,
    ComboboxBase,
  },

  props: {
    community: { type: Object, default: () => ({}) },
    question: { type: Object, default: () => undefined },
  },
  data(vm) {
    return {
      items: [],
      isSearching: false,
      isLoading: false,
      search: null,
      model: vm.question,
      searchAfter: 3,
    };
  },
  computed: {
    ariaLabel() {
      return "Question";
    },
  },
  watch: {
    search(val) {
      if (!val || val.length < this.searchAfter) {
        this.items = [];

        return;
      }

      this.isSearching = true;
      getResultsWithDelay.call(this, val);
    },
    question(question) {
      this.model = question;
    },
  },
  methods: {
    questionSelected(question) {
      this.$emit("question-selected", question);
      this.$nextTick(() => this.$refs.clearButton.focus());
    },
    clearQuestion() {
      this.$emit("question-selected", null);
    },
    updateSearch(value) {
      this.search = value;
    },
  },
};
</script>
